import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconMinimize16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7 15H5V12.4141L1.70703 15.707L0.292969 14.293L3.58594 11H1V9H7V15Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M15.707 1.70703L12.4141 5H15V7H9V1H11V3.58594L14.293 0.292969L15.707 1.70703Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconMinimize24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11 20H9V16.4141L3.70703 21.707L2.29297 20.293L7.58594 15H4V13H11V20Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M21.707 3.70703L16.4141 9H20V11H13V4H15V7.58594L20.293 2.29297L21.707 3.70703Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconMinimize48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M21 42H19V30.4141L3.70703 45.707L2.29297 44.293L17.5859 29H6V27H21V42Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M45.707 3.70703L30.4141 19H42V21H27V6H29V17.5859L44.293 2.29297L45.707 3.70703Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
